import React, {Fragment} from 'react';
import {Grid, Typography, useTheme} from '@material-ui/core';
import {ItemColor} from 'modules/demo';

function Palette() {
    const palette = useTheme().palette;
    return (
        <Fragment>
            <Typography align='center'>{'Palette'}</Typography>
            <Typography gutterBottom>{'Primary'}</Typography>
            <Grid container spacing={2}>
                <ItemColor name='primary.light' color={palette.primary.light} />
                <ItemColor name='primary.main' color={palette.primary.main} />
                <ItemColor name='primary.dark' color={palette.primary.dark} />
            </Grid>
            <Typography gutterBottom>{'Secondary'}</Typography>
            <Grid container spacing={2}>
                <ItemColor
                    name='secondary.light'
                    color={palette.secondary.light}
                />
                <ItemColor
                    name='secondary.main'
                    color={palette.secondary.main}
                />
                <ItemColor
                    name='secondary.dark'
                    color={palette.secondary.dark}
                />
            </Grid>
            <Typography gutterBottom>{'Error'}</Typography>
            <Grid container spacing={2}>
                <ItemColor name='error.light' color={palette.error.light} />
                <ItemColor name='error.main' color={palette.error.main} />
                <ItemColor name='error.dark' color={palette.error.dark} />
            </Grid>
            <Typography gutterBottom>{'Warning'}</Typography>
            <Grid container spacing={2}>
                <ItemColor name='warn.light' color={palette.warning.light} />
                <ItemColor name='warn.main' color={palette.warning.main} />
                <ItemColor name='warn.dark' color={palette.warning.dark} />
            </Grid>
            <Typography gutterBottom>{'Info'}</Typography>
            <Grid container spacing={2}>
                <ItemColor name='info.light' color={palette.info.light} />
                <ItemColor name='info.main' color={palette.info.main} />
                <ItemColor name='info.dark' color={palette.info.dark} />
            </Grid>
            <Typography gutterBottom>{'Success'}</Typography>
            <Grid container spacing={2}>
                <ItemColor name='success.light' color={palette.success.light} />
                <ItemColor name='success.main' color={palette.success.main} />
                <ItemColor name='success.dark' color={palette.success.dark} />
            </Grid>
            <Typography gutterBottom>{'Text'}</Typography>
            <Grid container spacing={2}>
                <ItemColor name='text.primary' color={palette.text.primary} />
                <ItemColor
                    name='text.secondary'
                    color={palette.text.secondary}
                />
                <ItemColor name='text.disabled' color={palette.text.disabled} />
            </Grid>
            <Typography gutterBottom>{'Background'}</Typography>
            <Grid container spacing={2}>
                <ItemColor
                    name='background.default'
                    color={palette.background.default}
                />
                <ItemColor
                    name='background.paper'
                    color={palette.background.paper}
                />
            </Grid>
        </Fragment>
    );
}

export default Palette;
